export default __webpack_public_path__ + "images/52cb3f6708a3e1e1a7b65c253e9fb5a0.png";